import { combineReducers } from 'redux';
import { ResultsLegFragment, SearchResultsQuery } from '@websky/graphql';
import { Leg } from '../types';
import { SelectedFare } from '../../DesktopFlight/types';
import { selectedFaresReducer } from './selectedFares/reducers';
import { currentLegReducer } from './currentLeg/reducers';
import { legsReducer } from './legs/reducers';
import legInView from './legInView/reducers';
import infoMessagesReducer, { InfoMessagesState } from './infoMessages/reducers';
import searchResultsReducer from './searchResults/reducers';
import { errorReducer, ErrorState } from '@entities/error';

export interface ResultsState {
	legInView: ResultsLegFragment;
	selectedFares: SelectedFare[];
	currentLeg: number;
	legs: Leg[];
	infoMessages: InfoMessagesState;
	searchResults: SearchResultsQuery['SearchResult'] | null;
	error?: ErrorState;
}

export const rootReducer = combineReducers<ResultsState>({
	selectedFares: selectedFaresReducer,
	currentLeg: currentLegReducer,
	legs: legsReducer,
	legInView,
	infoMessages: infoMessagesReducer,
	searchResults: searchResultsReducer,
	error: errorReducer
});
